import { styled } from "@mui/material";
const Scroller = styled("div", {
  name: "ScrollbarScroller",
  shouldForwardProp: (prop) => prop !== "hideOverflow",
  slot: "Scroller"
})((props) => ({
  "&::-webkit-scrollbar": {
    height: "8px",
    opacity: 0,
    width: "8px"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "10px",
    opacity: 0
  },
  "&::-webkit-scrollbar-track": {
    background: "rgba(222, 222, 222, .75)",
    opacity: 0
  },
  display: "block",
  overflowX: props.hideOverflow === "x" ? "hidden" : "auto",
  overflowY: props.hideOverflow === "y" ? "hidden" : "auto",
  position: "relative",
  width: "100%"
}));
export {
  Scroller
};
//# sourceMappingURL=Scroller.js.map
